// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cashreceipts_container__jIEX0 {
  display: flex;
  justify-content: flex-end;
  margin-right: 20px;
  text-align: center;
  color: #055437;
  width: 100%;
}

.cashreceipts_content__PYYSa {
  display: flex;
  cursor: pointer;
}

.cashreceipts_title__zbzMU {
  padding-top: 0.1em;
  padding-left: 0.5em;
  text-decoration: none;
  font-weight: 600;
  display: flex;
  width: 100%;
  font-size: 1.2em;
  font-family: 'IBM Plex Sans', sans-serif;
}

.cashreceipts_cashTitleContainer__auiRW {
  display: flex;
  margin-top: 10px;
  /* justify-content: end;
    width: 100%; */
}

.cashreceipts_cashTitle__eF0Lt {
  font-weight: bolder;
  text-decoration: none;
  display: flex;
  font-size: 1.8em;
  font-family: 'IBM Plex Sans', sans-serif;
  color: #055437;
}
`, "",{"version":3,"sources":["webpack://./src/components/styles/cashreceipts.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB;kBACgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,aAAa;EACb,gBAAgB;EAChB,wCAAwC;EACxC,cAAc;AAChB","sourcesContent":[".container {\n  display: flex;\n  justify-content: flex-end;\n  margin-right: 20px;\n  text-align: center;\n  color: #055437;\n  width: 100%;\n}\n\n.content {\n  display: flex;\n  cursor: pointer;\n}\n\n.title {\n  padding-top: 0.1em;\n  padding-left: 0.5em;\n  text-decoration: none;\n  font-weight: 600;\n  display: flex;\n  width: 100%;\n  font-size: 1.2em;\n  font-family: 'IBM Plex Sans', sans-serif;\n}\n\n.cashTitleContainer {\n  display: flex;\n  margin-top: 10px;\n  /* justify-content: end;\n    width: 100%; */\n}\n\n.cashTitle {\n  font-weight: bolder;\n  text-decoration: none;\n  display: flex;\n  font-size: 1.8em;\n  font-family: 'IBM Plex Sans', sans-serif;\n  color: #055437;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `cashreceipts_container__jIEX0`,
	"content": `cashreceipts_content__PYYSa`,
	"title": `cashreceipts_title__zbzMU`,
	"cashTitleContainer": `cashreceipts_cashTitleContainer__auiRW`,
	"cashTitle": `cashreceipts_cashTitle__eF0Lt`
};
export default ___CSS_LOADER_EXPORT___;
